
import { format } from 'date-fns'
import { configApi } from '../http-client.js'
import { DATE_FORMAT } from '../date-formatting.js'

export const getSiteScans = () => {
	return configApi.get('api/SiteScanner').then(({ data }) => {
		return {
			data: {
				singleScans: data.singleScans?.map(scan => {
					return {
						...scan,
						id: scan.id !== null ? scan.id : 'No Number',
						dateRequested: format(new Date(scan.dateRequested), DATE_FORMAT),
						dateCompleted: scan.dateCompleted ? format(new Date(scan.dateCompleted), DATE_FORMAT) : ''
					}
				}),
				recurringScans: data.recurringScans?.map(scan => {
					return {
						...scan,
						dateRequested: format(new Date(scan.dateRequested), DATE_FORMAT),
						dateCompleted: scan.dateCompleted ? format(new Date(scan.dateCompleted), DATE_FORMAT) : '',
						dateRequestedUnformatted: scan.dateRequested
					}
				}),
				lookupData: data.lookupData
			}
		}
	})
}

export const requestScan = scanRequest => configApi.post('api/SiteScanner', scanRequest)
export const requestScheduledScan = scanRequest => configApi.post('api/SiteScanner/CreateSchedule', scanRequest)
export const getScanReport = scanGuid => configApi.get(`api/SiteScanner/Result/${scanGuid}`)
export const updateCookieDetails = updateCookieDetailsRequest => configApi.put('api/SiteScanner/UpdateCookieDetails', updateCookieDetailsRequest)

export const downloadScanFile = (scanGuid, downloadType, cookieName, forceFresh = false) =>
	configApi.post('api/SiteScanner/Download', { scanGuid, downloadType, cookieName, forceFresh })

export const deleteCookieScan = scanGuid => configApi.delete(`api/SiteScanner/${scanGuid}`)

export const deleteScheduledCookieScan = scheduledScanId => configApi.delete(`api/SiteScanner/${scheduledScanId}`)

export const cancelRecurringScan = groupedSchedulesId => configApi.post(`api/SiteScanner/cancelRecurringScan/${groupedSchedulesId}`)

export const getScanResultsComparison = compareRequest => configApi.post('api/SiteScanner/CompareResults', compareRequest)

export const getScanSummary = scanGuid => configApi.get(`api/SiteScanner/SummaryCards/${scanGuid}`)

export const getScanChart = (scanGuid, chartType) => configApi.get(`/api/SiteScanner/Summary/SummaryCharts/${scanGuid}/${chartType}`)

export const getCookieOverview = (scanGuid, params) => configApi.get(`api/SiteScanner/CookieOverview/${scanGuid}`, { params })

export const getCookieLookup = (scanGuid, domainName, cookieCategoryId, pageSize = 15, pageNum = 1, orderBy = 0, orderDirection = 'asc') => configApi.get(`api/SiteScanner/CookieLookup/${scanGuid}/${domainName}?PageSize=${pageSize}&PageNum=${pageNum}&OrderBy=${orderBy}&OrderDirection=${orderDirection}&categoryId=${cookieCategoryId}`)

export const getTrackerOverview = scanGuid => configApi.get(`api/SiteScanner/TrackerOverview/${scanGuid}`)

export const getTrackerLookup = (scanGuid, domainName, pageSize = 15, pageNum = 1, orderBy = 0, orderDirection = 'asc') => configApi.get(`api/SiteScanner/TrackerLookup/${scanGuid}/${encodeURIComponent(domainName)}?PageSize=${pageSize}&PageNum=${pageNum}&OrderBy=${orderBy}&OrderDirection=${orderDirection}`)

export const getResourceOverview = scanGuid => configApi.get(`api/SiteScanner/ResourcesOverview/${scanGuid}`)

export const getResourceLookup = (scanGuid, domainName, pageSize = 15, pageNum = 1, orderBy = 0, orderDirection = 'asc') => configApi.get(`api/SiteScanner/ResourcesLookup/${scanGuid}/${encodeURIComponent(domainName)}?PageSize=${pageSize}&PageNum=${pageNum}&OrderBy=${orderBy}&OrderDirection=${orderDirection}`)

export const getScanDetails = (scanGuid, scheduledScanId) => {
	const params = new URLSearchParams()
	if (scanGuid) params.append('scanGuid', scanGuid)
	if (scheduledScanId) params.append('scheduledScanId', scheduledScanId)
	return configApi.get(`api/SiteScanner/ScanDetails?${params.toString()}`)
}

export const getScanActivity = scanGuid => configApi.get(`api/SiteScanner/ScanActivity/${scanGuid}`).then(({ data }) => data)

export const validateCsvExists = scanGuid => configApi.post('api/SiteScanner/CsvExists', { scanGuid }).then(res => res.data)

export const downloadCsvFromS3 = temporaryURL => window.open(temporaryURL)

// Returns array of CsvStatusViewModel
export const getCsvStatuses = scanGuid => configApi.get(`api/SiteScanner/CsvStatus/${scanGuid}`).then(r => r.data)
